
const wordpress = [
    {img: './assets/images/2022-05-03-22-28-vhs-henstedt-ulzburg.de.png', name: 'VHS', tech: 'HTML, CSS, JavaScript, PHP', text: 'Wordpress/WooCommerce Website for a local School', link: 'https://vhs-henstedt-ulzburg.de/' },
    {img: './assets/images/2022-05-03-22-54-vbfv.de.png', name: 'VBFV', tech: 'HTML, CSS, JavaScript, PHP', text: 'Wordpress Website for a Insurance Company', link: 'https://vbfv.de' },
    {img: './assets/images/phonecityrepair.png', name: 'PhoneCityRepair', tech: 'HTML, CSS, JavaScript, PHP', text: 'Phone Repair WooCommerce Shop', link: 'https://phonecityrepair.de/' },
    {img: './assets/images/schaedlingsexperten.png', name: 'Schädlingsexperten', tech: 'HTML, CSS, JavaScript, PHP', text: 'Website for a local Company', link: 'https://die-schaedlingsexperten.de/' },
    {img: './assets/images/classicstyle-hh.png', name: 'Classic Style HH', tech: 'HTML, CSS, JavaScript, PHP', text: 'Website for a local Car Dealer', link: 'https://classicstyle-hh.de/' },
    {img: './assets/images/kskingde.png', name: 'KSK Ingenieure', tech: 'HTML, CSS, JavaScript, PHP', text: 'Website for a Engineers Company', link: 'https://ksking.de/' }
]


export default function Portfolio() {
    return (

    <div id="portfoliorender" className="container mx-auto mt-20 grid grid-cols-1 gap-8 md:grid-cols-2 xl:grid-cols-3 pb-20">
        { wordpress.map((item) => (   
        <div className="drop-shadow-xl hover:drop-shadow-2xl hover:-translate-y-1 hover:scale-104 duration-300">
            <div className="rounded-lg overflow-hidden">
            <div className="relative overflow-hidden pb-60">
                <img className="absolute h-full w-full object-cover object-top" src={item.img} alt={item.name} />
            </div>
            <div className="relative bg-neutral-900">
                <div className="py-10 px-8">
                <h3 className="text-2xl font-bold text-orange-600">{item.name}</h3>
                <div className="text-white text-sm font-medium flex mb-4 mt-2">
                    <p>{item.tech}</p>
                    
                </div>
                <p className="leading-7 text-white">
                    {item.text}
                </p>
                <div className="mt-10 flex justify-between items-center">
                    <div>
                    <img src="./assets/images/WPlogo.png" width="25px" alt="" className="w-6"/>
                    </div>
                    <a href={item.link} target="_blank" rel="noreferrer" className="w-1/3 float-right flex items-center justify-center px-4 py-2 border border-transparent text-white font-medium rounded-md text-neutral-900 bg-orange-600 hover:bg-orange-700">
                    View</a>
                </div>
                </div>
            </div>
            </div>
        </div>
        ))}
    </div>
    )
    
}



